angular.module('shared').factory('AdminUserService', function() {
  var AdminUserService, admin, getAdminUser, parseAdminUser;
  admin = void 0;
  getAdminUser = function() {
    var attrs, el;
    el = $('#admin-user-data');
    if (!el.html()) {
      return;
    }
    attrs = $.parseJSON(el.html());
    el.remove();
    admin = parseAdminUser(attrs);
    return admin;
  };
  parseAdminUser = function(admin) {
    var permissions;
    permissions = admin.permissions = {};
    admin.admin_permissions.forEach(function(permission) {
      return admin.permissions[permission] = true;
    });
    return admin;
  };
  AdminUserService = {
    get: function() {
      return admin || getAdminUser();
    },
    has: function(permission) {
      if (!admin) {
        getAdminUser();
      }
      if (!admin) {
        return true;
      } else {
        return admin.permissions[permission];
      }
    }
  };
  return AdminUserService;
});
